export default __webpack_public_path__ + "static/media/progress-chart.38943cdd.svg";